<template>
  <span v-if="items.length > 0">
    <v-chip
      v-if="items.length === 1"
      small
      v-bind="$attrs"
      :color="colorFn ? colorFn(items[0]) : undefined"
      :dark="dark"
      :close="!!closeFn"
      @click:close="closeFn && closeFn(items[0])"
    >
      <v-icon v-if="iconFn" small left>{{ iconFn(items[0]) }}</v-icon>
      {{ label(items[0]) }}
    </v-chip>
    <v-menu v-else bottom offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-chip small v-bind="{ ...$attrs, ...attrs }" v-on="on">
          {{ items.length }} {{ items.length === 1 ? singular : plural }}
          <v-icon small right>$chevronDown</v-icon>
        </v-chip>
      </template>
      <v-sheet class="pa-2 d-flex flex-wrap" style="gap: 4px; max-width: 300px">
        <v-chip
          v-for="item in items"
          :key="item"
          small
          :color="colorFn ? colorFn(item) : undefined"
          :dark="dark"
          :close="!!closeFn"
          @click:close="closeFn && closeFn(item)"
        >
          <v-icon v-if="iconFn" small left>{{ iconFn(item) }}</v-icon>
          {{ label(item) }}
        </v-chip>
      </v-sheet>
    </v-menu>
  </span>
</template>

<script>
export default {
  name: "FilterChip",
  inheritAttrs: false,
  props: {
    items: { type: Array, default: () => [] },
    labelFn: { type: Function, default: (v) => String(v) },
    singular: { type: String, default: "item" },
    plural: { type: String, default: "items" },
    capitalize: { type: Boolean, default: false },
    closeFn: { type: Function, default: null },
    colorFn: { type: Function, default: null },
    iconFn: { type: Function, default: null },
    dark: { type: Boolean, default: false },
  },
  methods: {
    label(item) {
      const text = this.labelFn(item) || "";
      return this.capitalize
        ? text.replace(/\b\w/g, (c) => c.toUpperCase())
        : text;
    },
  },
};
</script>
